import { seed_is_initalised, useLocalStorage } from "../../Utils"
import Control from "./Nameplate/Control"
import React, { useState, useCallback } from "react"
import ResultSet from "./Nameplate/Result"
import NameplateInit from "./Nameplate/NameplateInit"
import ControlInit from "./Nameplate/ControlInit"
import ResultInit from "./Nameplate/ResultInit"
import { defaultImportData, defaultProfile } from "../../DefaultEntries"
import { useTranslation } from "react-i18next"
import { add_nameplate } from "./Util/ProfileHandler"
import { NamePlateSeeds as Seeds } from "./Util/NamePlateSeeds"

const unit_name = "RewardRandomPool_NamePlateBg"

const Nameplate = props => {
    const [userData, setUserData] = useLocalStorage("importData", defaultImportData)
    const [profileData, setProfileData] = useLocalStorage("profile", defaultProfile)

    const { t } = useTranslation()

    const init_current_seed = () => {
        const nns = new Seeds(profileData, userData)
        return nns.get_current_seed(userData)
    }

    const [currentSeed, setCurrentSeed] = useState(init_current_seed())
    const [displayResults, setDisplayResults] = useState([])
    const [possibleResults, setPossibleResults] = useState([])

    const initialised = seed_is_initalised(userData, unit_name)

    const updateSeedHandler = (newSeed, raw) => {
        add_nameplate(
            raw.map(e => e.Id),
            profileData,
            setProfileData
        )
        setCurrentSeed(newSeed)
        const nns = new Seeds(profileData, userData)
        const original = nns.set_current_seed(userData, newSeed)
        setUserData(original)
        setDisplayResults([])
    }

    const calculateResultHandler = () => {
        const nns = new Seeds(profileData, userData)
        setDisplayResults(nns.calculateResultHandler(currentSeed))
    }

    const find_seed = entries => {
        const nns = new Seeds(profileData, userData)
        const potential_seeds = nns.find_seed(entries)
        setPossibleResults(potential_seeds)
    }

    const store_seed_from_finding = () => {
        if (possibleResults.length === 1) {
            updateSeedHandler(possibleResults[0][0].get_state(), possibleResults[0][1])
        }
    }

    const resetSeed = useCallback(() => {
        if (!window.confirm(t("misc:Common.DeleteConfirmation"))) return
        const nns = new Seeds(profileData, userData)
        const original = nns.null_seed(userData)
        setUserData(original)
    }, [userData, t, setUserData, profileData])
    if (!initialised) {
        return (
            <>
                <NameplateInit />
                <ControlInit findSeed={find_seed} localKey={unit_name} />
                <ResultInit possibleResults={possibleResults} storeRes={store_seed_from_finding} />
            </>
        )
    }

    return (
        <>
            <Control calculateResults={calculateResultHandler} resetSeed={resetSeed} />
            <ResultSet results={displayResults} updateSeed={updateSeedHandler} />
        </>
    )
}

export default Nameplate
